module.exports = __webpack_public_path__ + "static/media/world.9408337e.svg";